import {
  HeaderProject,
  useGetFolderQuery,
  ProjectDnD,
  DndProps,
  Grouping,
  Item,
  DnDNodeProps,
  Calendar,
  AlertDialog,
  selectUser,
  BackdropLoading,
  useProjectDnDDefaultStyles,
  HeaderProjectPreview,
  ContextMenu,
  Stage,
  AlertForm,
  AlertFormProps,
  AvatarProps,
  CalendarItem,
  CalendarStage,
  JFormik,
  AlertDialogProps,
} from '@centerpiece/components';
import {
  TaskOutlined,
  DeleteOutlineOutlined,
  FeaturedPlayListOutlined,
  ClassOutlined,
  EventOutlined,
  HandshakeOutlined,
  Unarchive,
  Archive,
} from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Container,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ProjectTabDrawer } from 'drawers/ProjectTabDrawer';
import moment from 'moment';
import { useState, useMemo, useRef, useEffect, Fragment } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import {
  project as projectApi,
  useCreateCoordinationMutation,
  useCreateEventMutation,
  useCreateGroupingMutation,
  useCreateProjectTemplateMutation,
  useCreateTaskMutation,
  useDeleteGroupingMutation,
  useGetItemStatusesQuery,
  useGetProjectQuery,
  useGetSubscribersQuery,
  useGetProjectStagesQuery,
  usePatchCoordinationMutation,
  usePatchEventMutation,
  usePatchGroupingMutation,
  usePatchProjectMutation,
  usePatchTaskMutation,
  useUpdateItemMutation,
  useCreateRelationshipMutation,
  useDeleteRelationshipMutation,
  useUpdateTaskMutation,
  useLazyGetTaskQuery,
  useLazyGetEventQuery,
  useLazyGetCoordinationQuery,
  useLazyGetGroupingQuery,
  useLazyGetStageQuery,
  subscribeEvent,
  subscribeCoordination,
  subscribeTask,
  subscribeRelationship,
  subscribeGrouping,
  subscribeStage,
  useLazyGetRelationshipsQuery,
  useGetGroupingsQuery,
  usePatchStageMutation,
  useCreateStageMutation,
  usePatchItemMutation,
  useGetSubscriptionContactsQuery,
  useGetProjectContactsQuery,
  useLazyGetProjectContactsQuery,
  useCreateProjectContactMutation,
  useDeleteProjectContactMutation,
  subscribeProjectContacts,
  useGetProjectStatesQuery,
  useGetItemsQuery,
  useGetTagsQuery,
  useLazyGetItemTagsQuery,
  subscribeItemTags,
  useCreateItemTagMutation,
  useDeleteItemTagMutation,
  useGetCommentsQuery,
  subscribeItem,
  useCreateProjectWorkflowMutation,
} from 'store/api';
import { useLogout } from 'utils/logout.utils';
import {
  getItemDates,
  getOptimizedProjectTree,
  incompleteChild,
} from 'utils/project.utils';
import { useSelector } from 'react-redux';
import {
  getItemStatus,
  getStatusColorFromDate,
  // getStatusFromDate,
} from 'utils/status.utils';
import { ProjectContext, ProjectProvider } from 'contexts/project.context';
import {
  Comment,
  Coordination,
  Project,
  Message,
  Event,
  Task,
  Subscriber,
  Stage as StageModel,
  Grouping as GroupingModel,
  ItemStatus,
  Outcome,
  SubscriptionContact,
  ProjectContact,
  NodeItem,
  ITEMSTATUSES,
  Tag,
} from 'store/api/models';
import { toast } from 'react-toastify';
import { projectSteps } from 'tutorials/project.tutorial';
import { useTutorialContext } from 'tutorials/tutorial.context';
import { ContactTooltip } from './ContactTooltip';
import { ItemPreviewDialog } from 'dialogs/ItemPreviewDialog';
import { ItemTabDrawer } from 'drawers/ItemTabDrawer';
import { ProjectViewStage } from './project/ProjectViewStage';
import { ContactComponent } from './ContactComponent';

interface AlertDetails {
  title: string;
  content: any;
  onConfirm?: Function;
  confirmLabel?: string;
}

export interface ProjectComponentProps {
  header?: boolean;
  id: number;
  exampleProject?: any;
  speedDial?: boolean;
  calendar?: boolean;
  preview?: boolean;
  template?: boolean;
  onBack?: Function;
  onLogoClick?: Function;
  disabled?: boolean;
  afterSave?: Function;
}

export const ProjectComponent = ({
  header = true,
  id,
  exampleProject,
  speedDial = true,
  calendar = true,
  preview = false,
  template = false,
  disabled = false,
  afterSave = () => {},
  onBack,
  onLogoClick,
}: ProjectComponentProps) => {
  const [anchorEl, setAnchorElActual] =
    useState<null | {
      anchor: HTMLElement;
      clientX: any;
      clientY: any;
      data?: any;
    }>(null);
  const setAnchorEl = (e: any) => {
    if (!e) {
      setHighlightNode(undefined);
    }
    setAnchorElActual(e);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const onLogout = useLogout();
  const [loading, setLoading] = useState<boolean>(false);
  const itemsRef = useRef({});
  const [filter, setFilter] = useState<string>('Active');
  const [activeNode, setActiveNodeActual] = useState<DnDNodeProps>();
  const setActiveNode = (node: DnDNodeProps | undefined) => {
    if (!disabled) {
      setActiveNodeActual(node);
    }
  };
  const [itemType, setItemType] = useState<{
    label: string;
    filter: string;
  }>({
    label: 'All',
    filter: 'All',
  });
  const [selectedTag, setSelectedTag] = useState<{
    name: string;
    id: number;
  }>({
    name: 'All',
    id: -1,
  });
  const [activeDialog, setActiveDialogActual] = useState<DnDNodeProps>();
  const setActiveDialog = (node: DnDNodeProps | undefined) => {
    if (!disabled) {
      setActiveDialogActual(node);
    }
  };
  const [highlightNode, setHighlightNode] = useState<DnDNodeProps>();
  const [openProjectInfo, setOpenProjectInfo] = useState<string>();
  const [openSpeedDial, setOpenSpeedDial] = useState<boolean>(false);
  const [alertDetails, setAlertDetails] = useState<AlertDialogProps>();
  const [alertFormDetails, setAlertFormDetails] = useState<AlertFormProps>({
    open: false,
  });
  const handleOpenSpeedDial = () => setOpenSpeedDial(true);
  const handleCloseSpeedDial = () => setOpenSpeedDial(false);
  // eslint-disable-next-line
  const { contact: userContact } = useSelector(selectUser);

  const [patchProject] = usePatchProjectMutation();
  const [createProjectTemplate] = useCreateProjectTemplateMutation();
  const [createGrouping] = useCreateGroupingMutation();
  const [createStage] = useCreateStageMutation();
  const [patchGrouping, patchGroupingResult] = usePatchGroupingMutation();
  const [patchStage, patchStageResult] = usePatchStageMutation();
  const [updateItem] = useUpdateItemMutation();
  const [createTask] = useCreateTaskMutation();
  const [patchTask, patchTaskResult] = usePatchTaskMutation();
  const [patchItem, patchItemResult] = usePatchItemMutation();
  const [patchEvent, patchEventResult] = usePatchEventMutation();
  const [patchCoordination, patchCoordinationResult] =
    usePatchCoordinationMutation();

  const projectDnDStyles = useProjectDnDDefaultStyles();
  const theme = useTheme();
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));

  const [openContact, setOpenContactActual] = useState<{
    open: boolean;
    id?: number;
    disabled?: boolean;
    callback?: Function;
    initialValues?: any;
  }>({ open: false });
  const setOpenContact = (value: any) => {
    setOpenContactActual(value);
    setAlertDetails(pv => ({ ...pv, openAlternate: !!value?.open } as any));
  };
  useEffect(() => {
    if (location.hash !== '') {
      if (location.hash.includes('#details')) {
        const itemMatch = location?.hash?.match(/#details=(\s+)/);
        setOpenProjectInfo(itemMatch?.[1] || 'info');
      } else {
        //clear hash after reading
        const itemMatch = location?.hash?.match(/#(\w)=(\d+)/);
        window.history.replaceState(null, '', location.pathname);
        let element = '';
        switch (itemMatch?.[1]) {
          case 'c':
            element = 'coordination';
            break;
          case 'e':
            element = 'event';
            break;
          case 't':
            element = 'task';
            break;
        }
        const id = Number(itemMatch?.[2]);
        if (element !== '' && id > 0) {
          const asyncFunc = async () => {
            const elemID = `${element}-${id}`;
            await waitForElm(elemID);
            const currentElem = (itemsRef.current as any)[elemID];
            await currentElem.expandParent();
            setTimeout(function () {
              currentElem.scrollRef?.current?.scrollIntoView({
                behavior: 'smooth',
              });
            }, 500);
            currentElem.scrollRef?.current?.scrollIntoView({
              behavior: 'smooth',
            });
            const currentItem = (itemsRef.current as any)[`item-${id}`];
            currentItem.scrollRef.current.scrollIntoView({
              behavior: 'smooth',
            });
            if (!template && !preview) {
              setActiveNode(currentItem?.node);
            }
          };
          asyncFunc();
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  const { state, setState } = useTutorialContext();

  useEffect(() => {
    if (state.tourActive) {
      setTimeout(function () {
        setState(currState => {
          return {
            ...currState,
            run: true,
            triggers: {
              ...currState.triggers,
              openProjectDetailsDrawer: () => setOpenProjectInfo('info'),
              closeProjectDetailsDrawer: () => setOpenProjectInfo(undefined),
              toggleCalendar: () => {
                document.getElementById('calendarExpand')?.click();
              },
              openCoordinationDrawer: async () => {
                const elemID = `coordination-21198`;
                const currentItem = (itemsRef.current as any)[elemID];
                await currentItem.expandParent();
                const currentNode = (itemsRef.current as any)[`item-21198`];
                currentNode.onClick();
              },
              closeCoordinationDrawer: () => setActiveNode(undefined),
              openTaskDrawer: async () => {
                const elemID = `task-21197`;
                const currentItem = (itemsRef.current as any)[elemID];
                await currentItem.expandParent();
                const currentNode = (itemsRef.current as any)[`item-21197`];
                currentNode.onClick();
              },
              closeTaskDrawer: () => setActiveNode(undefined),
              openSpeedDial: () => setOpenSpeedDial(true),
              closeSpeedDial: () => setOpenSpeedDial(false),
            },
          };
        });
      }, 500);
    }
    // eslint-disable-next-line
  }, []);

  const [expanded, setExpanded] = useState<boolean>(false);
  return (
    <ProjectProvider
      id={id}
      template={template}
      disabled={disabled}
      afterSave={afterSave}
      itemsRef={itemsRef}
      preview={preview}
    >
      <ProjectContext.Consumer>
        {({
          id,
          project,
          projectLoading,
          projectColors,
          preview,
          template,
          disabled,
          items,
          itemsFetching,
          comments,
          tags,
          project_contacts,
          msgs,
          cmts,
          projectTree,
          events,
          project_stages,
          project_states,
          refetchProject,
          currentStage,
          nextStage,
          statuses,
          subscribers,
          completeChildren,
        }) => {
          const numChats = comments?.filter(
            (comment: Comment) =>
              comment?.contacts?.filter(
                (contact: any) =>
                  contact.status === 'New' && contact.contact === userContact
              )?.length > 0
          )?.length;

          const setArchivedChildren = async (
            children?: NodeItem[],
            archived?: boolean
          ) => {
            await children?.forEach(async child => {
              await setArchivedChildren(child.items, archived);
              await patchItem({
                id: child.id,
                archived: archived ? true : false,
              } as any);
            });
          };

          const onMoveComplete = async ({ from, to, position }: DndProps) => {
            if (position === 'node') {
              switch (from.nodeType) {
                case 'stage':
                  break;
                case 'grouping':
                  if (to.nodeType === 'stage') {
                    updateItem({
                      id: from.id,
                      item: to.id,
                      sequence: 0,
                      project: Number(id),
                    } as any);
                  }
                  break;
                case 'task':
                case 'event':
                case 'coordination':
                case 'item':
                  // add to sequence zero or beginning
                  updateItem({
                    id: from.id,
                    item: to.id,
                    sequence: 0,
                    project: Number(id),
                  } as any);

                  break;
                default:
                  break;
              }
            } else if (position === 'prev') {
              if (from.nodeType === 'stage' && to.nodeType === 'stage') {
                updateItem({
                  id: from.id,
                  project: Number(id),
                  // item: to.parentId,
                  sequence: to.sequence,
                } as any);
              } else if (
                ['grouping', 'task', 'coordination', 'event', 'item'].includes(
                  from.nodeType
                ) &&
                ['grouping', 'task', 'coordination', 'event', 'item'].includes(
                  to.nodeType
                )
              ) {
                updateItem({
                  id: from.id,
                  project: Number(id),
                  item: to.parentId,
                  sequence: to.sequence,
                } as any);
              }
            } else if (position === 'next') {
              if (from.nodeType === 'stage' && to.nodeType === 'stage') {
                updateItem({
                  id: from.id,
                  project: Number(id),
                  // item: to.parentId,
                  sequence: to.sequence + 1,
                } as any);
              } else if (
                ['grouping', 'task', 'coordination', 'event', 'item'].includes(
                  from.nodeType
                ) &&
                ['grouping', 'task', 'coordination', 'event', 'item'].includes(
                  to.nodeType
                )
              ) {
                updateItem({
                  id: from.id,
                  project: Number(id),
                  item: to.parentId,
                  sequence: to.sequence + 1,
                } as any);
              }
            }
            const elemID = `${from.nodeType}-${from.data.id}`;
            const updatedElem = (itemsRef.current as any)[elemID];
            await updatedElem.triggerReload();
          };

          const itemRender = (
            props: any,
            children: any[],
            calendar?: boolean
          ) => {
            const GroupingRender = calendar ? Fragment : Grouping;
            // const StageRender = calendar ? CalendarStage : Stage;
            const ItemRender = calendar ? CalendarItem : Item;
            switch (props.nodeType) {
              case 'stage':
                return (
                  <ProjectViewStage
                    calendar={calendar}
                    stage={props?.data?.stage}
                    nextStage={nextStage}
                    props={props}
                    setAlertDetails={(details: any) =>
                      setAlertDetails({
                        ...details,
                        alternate: (
                          <ContactComponent
                            close={() => setOpenContact({ open: false })}
                            {...openContact}
                          />
                        ),
                        openAlternate: openContact.open,
                        closeAlternate: () => setOpenContact({ open: false }),
                      })
                    }
                    setWorkflowDetails={(details: any) =>
                      setAlertFormDetails({
                        ...details,
                        alternate: (
                          <ContactComponent
                            close={() => setOpenContact({ open: false })}
                            {...openContact}
                          />
                        ),
                        openAlternate: openContact.open,
                        closeAlternate: () => setOpenContact({ open: false }),
                      })
                    }
                    setOpenContact={(values: any) => {
                      setOpenContact(values);
                      setAlertDetails((pv: any) => ({
                        ...pv,
                        alternate: (
                          <ContactComponent
                            close={() => setOpenContact({ open: false })}
                            {...values}
                          />
                        ),
                        openAlternate: values.open,
                        closeAlternate: () => setOpenContact({ open: false }),
                      }));
                    }}
                  />
                );
              case 'grouping':
                return (
                  <GroupingRender
                    key={`${props.nodeType}-${props?.data?.id}`}
                    documentId={`${props.nodeType}-${props?.data?.id}`}
                    ref={(el: any) => {
                      (itemsRef.current as any)[
                        `${props.nodeType}-${props?.data?.id}`
                      ] = el;
                    }}
                    {...props?.props}
                    showDetails={!props?.expanded}
                    data={props?.data?.grouping}
                    reloadParent={() => refetchProject()}
                    patchMutation={usePatchGroupingMutation}
                    lazyQuery={useLazyGetGroupingQuery}
                    queryParams={{
                      id: props?.data?.grouping?.id,
                    }}
                    selected={
                      activeNode?.id
                        ? activeNode?.id === props?.id &&
                          activeNode?.nodeType === props?.nodeType
                        : undefined
                    }
                    highlighted={
                      highlightNode?.id === props?.id &&
                      highlightNode?.nodeType === props?.nodeType
                    }
                    disabled={disabled}
                    template={template}
                  />
                );
              case 'item':
                return (
                  <ItemRender
                    key={`item-${props?.data?.id}`}
                    documentId={`item-${props?.data?.id}`}
                    ref={(el: any) => {
                      (itemsRef.current as any)[`item-${props?.data?.id}`] = el;
                    }}
                    {...props?.props}
                    data={props?.data}
                    showDetails={!props?.expanded}
                    statuses={statuses}
                    onStatusChange={async (
                      status: ItemStatus | null,
                      callback: Function
                    ) => {
                      let incomplete = incompleteChild(props?.children);
                      if (status?.id === ITEMSTATUSES.COMPLETE && incomplete) {
                        setAlertDetails({
                          open: true,
                          onClose: () => {},
                          title: `Can't complete item`,
                          content: `To complete the item you must complete all children items. Would you like to automatically complete all child items?`,
                          confirmLabel: 'Complete children items',
                          onConfirm: async () => {
                            await completeChildren(props?.children);
                            callback();
                            await patchTask({
                              id: props?.data?.task?.id,
                              status: status?.id,
                            } as any);
                            refetchProject();
                          },
                        });
                        return;
                      }
                      callback();
                      await patchTask({
                        id: props?.data?.task?.id,
                        status: status?.id,
                      } as any);
                      refetchProject();
                    }}
                    tags={{
                      data: props?.data?.tags,
                      options: tags,
                      lazyQuery: useLazyGetItemTagsQuery,
                      queryParams: {
                        params: {
                          item: props?.data?.id,
                          nested: 'all',
                        },
                      },
                      subscription: subscribeItemTags,
                      createMutation: useCreateItemTagMutation,
                      deleteMutation: useDeleteItemTagMutation,
                      onCreate: (item: any) => ({
                        tag: item.id,
                        item: props?.data?.id,
                      }),
                      reloadParent: () => refetchProject(),
                    }}
                    assignees={{
                      data: props?.data?.relationships?.map((c: any) => ({
                        avatar: {
                          ...c?.contact_r,
                          relationship: c?.id,
                          contact: c?.contact_r?.id,
                          name: `${c?.contact_r?.firstname} ${c?.contact_r?.lastname}`,
                        },
                      })),
                      tooltip: ContactTooltip,
                      options: subscribers?.map((subscriber: Subscriber) => ({
                        ...subscriber?.contact_r,
                        contact: subscriber?.contact_r?.id,
                        name:
                          subscriber?.contact_r.firstname &&
                          subscriber?.contact_r.firstname !== ''
                            ? `${subscriber.contact_r.firstname} ${subscriber.contact_r.lastname}`
                            : subscriber.contact_r.email,
                      })),
                      lazyQuery: useLazyGetRelationshipsQuery,
                      queryParams: {
                        params: {
                          item: props?.data?.id,
                          nested: 'all',
                        },
                      },
                      subscription: subscribeRelationship,
                      createMutation: useCreateRelationshipMutation,
                      deleteMutation: useDeleteRelationshipMutation,
                      onCreate: (item: any) => ({
                        type: 'Assigned',
                        contact: item.contact,
                        item: props?.data?.id,
                      }),
                      reloadParent: () => refetchProject(),
                    }}
                    title={
                      props?.data?.task?.title ||
                      props?.data?.event?.title ||
                      props?.data?.coordination?.title ||
                      ''
                    }
                    onItemClick={() => {
                      setActiveNode(props);
                    }}
                    onChatClick={() => {
                      setActiveNode(props);
                    }}
                    patchMutation={usePatchTaskMutation}
                    subscription={subscribeItem}
                    subscriptionParams={{
                      id: props?.data?.id,
                      params: { nested: 'all' },
                    }}
                    subscriptionTransform={(values: any) => {
                      if (values) {
                        const dates = getItemDates(values);
                        return { ...values, dates };
                      } else {
                        return values;
                      }
                    }}
                    lazyQuery={useLazyGetTaskQuery}
                    reloadParent={() => refetchProject()}
                    onDateChange={(newValue: any) =>
                      ({
                        id: props?.data?.task?.id,
                        project: Number(id),
                        due_date: newValue.end || null,
                        start_date: newValue.start || null,
                      } as Task)
                    }
                    icon={'task'}
                    icons={props.icons}
                    dates={
                      calendar
                        ? props.dates?.filter(
                            (d: any) => d.type === props.icons[0]
                          )
                        : props.dates
                    }
                    start_date={props?.data?.task?.start_date}
                    due_date={props?.data?.task?.due_date}
                    selected={
                      activeNode?.id
                        ? activeNode?.id === props?.id &&
                          activeNode?.nodeType === props?.nodeType
                        : undefined
                    }
                    highlighted={
                      highlightNode?.id === props?.id &&
                      highlightNode?.nodeType === props?.nodeType
                    }
                    complete={
                      props?.data?.status?.id === ITEMSTATUSES.COMPLETE ||
                      props.data.complete
                    }
                    menuItems={[
                      {
                        tooltip: props?.data?.archived
                          ? 'Unarchive'
                          : 'Archive',
                        icon: props?.data?.archived ? (
                          <Unarchive />
                        ) : (
                          <Archive />
                        ),
                        onClick: async () => {
                          // setHighlightNode(props)
                          setAlertDetails({
                            open: true,
                            onClose: () => {},
                            title: props?.data?.archived
                              ? 'Unarchive?'
                              : 'Archive?',
                            content: props?.data?.archived
                              ? 'This will add item(s) back to the project'
                              : 'This will remove all nested items from the view',
                            onConfirm: async () => {
                              await patchItem({
                                id: props?.data?.id,
                                archived: !props?.data?.archived,
                              } as any);
                              refetchProject();
                            },
                          });
                        },
                      },
                    ]}
                    edit={async ({ title }: { title: string }) => {
                      await patchTask({
                        id: props?.data?.task?.id,
                        title: title,
                        project: Number(id),
                      } as Task);
                    }}
                    disabled={disabled}
                    template={template}
                  />
                );
              default:
                return <div />;
            }
          };

          const createItem = async (
            type: string,
            createFunction: () => Promise<any>
          ) => {
            setLoading(true);
            if (highlightNode) {
              const nodeRef = (itemsRef.current as any)[
                `${highlightNode.nodeType}-${highlightNode?.data?.id}`
              ];
              const itemRef = (itemsRef.current as any)[
                `item-${highlightNode?.data?.id}`
              ];
              if (nodeRef && nodeRef.expandParent) {
                nodeRef.expandParent();
              }
              if (itemRef && itemRef.expand) {
                itemRef.expand();
                itemRef.scrollRef.current.scrollIntoView({
                  behavior: 'smooth',
                });
              }
            }
            const res = await createFunction();
            handleCloseSpeedDial();
            await refetchProject();
            // remove auto open after create
            await waitForElm(`${type}-${res.item}`);
            const currentItem = (itemsRef.current as any)[
              `${type}-${res.item}`
            ];
            currentItem.scrollRef.current.scrollIntoView({
              behavior: 'smooth',
            });
            // if (!template && !preview) {
            //   setActiveNode(currentItem?.node);
            // }
            setLoading(false);
          };

          return (
            <div style={{ overflowY: 'scroll', height: '100%' }}>
              {(loading ||
                projectLoading ||
                project?.id === 0 ||
                !projectTree) && <BackdropLoading />}
              <ContextMenu
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                menuItems={[
                  ...(anchorEl?.data?.nodeType === 'stage' &&
                  anchorEl?.data?.id > 0
                    ? [
                        {
                          icon: <FeaturedPlayListOutlined />,
                          label: 'Add Grouping',
                          onClick: async () => {
                            createItem('grouping', () =>
                              createGrouping({
                                title: 'Untitled Grouping',
                                project: id,
                                parent_item: anchorEl?.data?.id,
                                template: template,
                              }).unwrap()
                            );
                          },
                        },
                      ]
                    : []),
                  // {
                  //   icon: <HandshakeOutlined />,
                  //   label: 'Add Coordination',
                  //   onClick: async () => {
                  //     createItem('coordination', () =>
                  //       createCoordination({
                  //         title: 'Untitled Coordination',
                  //         project: id,
                  //         parent_item: anchorEl?.data?.id,
                  //         status: 1,
                  //         template: template,
                  //       }).unwrap()
                  //     );
                  //   },
                  // },
                  {
                    icon: <EventOutlined />,
                    label: 'Add Event',
                    onClick: async () => {
                      createItem('item', () =>
                        createTask({
                          title: 'Untitled Event',
                          project: id,
                          parent_item: anchorEl?.data?.id,
                          status: 1,
                          template: template,
                          form: {
                            tabs: {
                              info: {
                                visible: true,
                              },
                              event: {
                                visible: true,
                              },
                              comment: {
                                visible: true,
                              },
                              message: {
                                visible: false,
                              },
                            },
                          },
                        }).unwrap()
                      );
                    },
                  },
                  {
                    icon: <TaskOutlined />,
                    label: 'Add Task',
                    onClick: async () => {
                      createItem('item', () =>
                        createTask({
                          title: 'Untitled Task',
                          project: id,
                          parent_item: anchorEl?.data?.id,
                          status: 1,
                          template: template,
                          form: {
                            tabs: {
                              info: {
                                visible: true,
                              },
                              event: {
                                visible: false,
                              },
                              comment: {
                                visible: true,
                              },
                              message: {
                                visible: true,
                              },
                            },
                          },
                        }).unwrap()
                      );
                    },
                  },
                  ...(anchorEl?.data.nodeType === 'grouping' &&
                  anchorEl?.data?.id > 0
                    ? [
                        {
                          icon: anchorEl.data?.archived ? (
                            <Unarchive />
                          ) : (
                            <Archive />
                          ),
                          label: anchorEl.data?.archived
                            ? 'Unarchive Grouping'
                            : 'Archive Grouping',
                          onClick: async () => {
                            setAlertDetails({
                              open: true,
                              onClose: () => {},
                              title: anchorEl?.data?.archived
                                ? 'Unarchive?'
                                : 'Archive?',
                              content: anchorEl?.data?.archived
                                ? 'This will add item(s) back to the project'
                                : 'This will remove all nested items from the view',
                              onConfirm: async () => {
                                const nodeRef = (itemsRef.current as any)[
                                  `${anchorEl?.data.nodeType}-${anchorEl?.data?.data?.id}`
                                ];
                                if (anchorEl?.data?.id) {
                                  await setArchivedChildren(
                                    anchorEl?.data?.children,
                                    !anchorEl.data?.archived
                                  );
                                  await patchItem({
                                    id: anchorEl?.data?.id,
                                    archived: !anchorEl.data?.archived,
                                  } as any);
                                  await refetchProject();
                                }
                              },
                            });
                          },
                        },
                      ]
                    : []),
                  ...(anchorEl?.data.nodeType === 'stage' &&
                  anchorEl?.data?.id > 0
                    ? [
                        {
                          icon: anchorEl.data?.archived ? (
                            <Unarchive />
                          ) : (
                            <Archive />
                          ),
                          label: anchorEl.data?.archived
                            ? 'Unarchive Stage'
                            : 'Archive Stage',
                          onClick: async () => {
                            setAlertDetails({
                              open: true,
                              onClose: () => {},
                              title: anchorEl?.data?.archived
                                ? 'Unarchive?'
                                : 'Archive?',
                              content: anchorEl?.data?.archived
                                ? 'This will add item(s) back to the project'
                                : 'This will remove all nested items from the view',
                              onConfirm: async () => {
                                const nodeRef = (itemsRef.current as any)[
                                  `${anchorEl?.data.nodeType}-${anchorEl?.data?.data?.id}`
                                ];
                                if (anchorEl?.data?.id) {
                                  await setArchivedChildren(
                                    anchorEl?.data?.items,
                                    !anchorEl.data?.archived
                                  );
                                  await patchItem({
                                    id: anchorEl?.data?.id,
                                    archived: !anchorEl.data?.archived,
                                  } as any);
                                  await refetchProject();
                                }
                              },
                            });
                          },
                        },
                      ]
                    : []),
                ]}
              />
              {preview && header && (
                <HeaderProjectPreview
                  title={`${template ? `Template` : ``} ${
                    preview ? `Preview` : ``
                  }: ${project?.title || ''}`}
                  onBack={onBack}
                />
              )}
              {header && !preview && (
                <HeaderProject
                  title={
                    template
                      ? `Template: ${project?.title || ''}`
                      : project?.archived
                      ? `Archived: ${project?.title || ''}`
                      : `${project?.title || ''}`
                  }
                  assignees={{
                    force: true,
                    data: project_contacts.map(
                      (c: ProjectContact) =>
                        ({
                          ...c,
                          contact: c.contact_r?.id,
                        } as any)
                    ),
                    tooltip: ContactTooltip,
                    // options: subscribers?.map((subscriber: Subscriber) => ({
                    //   ...subscriber?.contact_r,
                    //   contact: subscriber?.contact_r?.id,
                    //   name:
                    //     subscriber?.contact_r.firstname &&
                    //     subscriber?.contact_r.firstname !== ''
                    //       ? `${subscriber.contact_r.firstname} ${subscriber.contact_r.lastname}`
                    //       : subscriber.contact_r.email,
                    // })),
                    // lazyQuery: useLazyGetProjectContactsQuery,
                    // queryParams: {
                    //   params: {
                    //     project: id,
                    //     nested: 'all',
                    //   },
                    // },
                    // subscription: subscribeProjectContacts,
                    // createMutation: useCreateProjectContactMutation,
                    // deleteMutation: useDeleteProjectContactMutation,
                    // onCreate: (item: any) => ({
                    //   contact: item.contact,
                    //   project: id,
                    // }),
                    reloadParent: () => refetchProject(),
                  }}
                  caption={template || !project?.due_date ? '' : 'Project due'}
                  caption_details={
                    template || !project?.due_date
                      ? ''
                      : moment(project?.due_date).format('MM/DD/YYYY')
                  }
                  status={getItemStatus({
                    status: project?.state_r || ({} as any),
                    disabled: disabled || template,
                    statuses: project_states,
                    color: projectColors?.status?.border,
                    onClick: (state: any) => {
                      patchProject({
                        id: Number(id),
                        state: state.id,
                      } as any);
                    },
                  })}
                  onLogoClick={
                    onLogoClick ? () => onLogoClick() : () => navigate('/')
                  }
                  onDashboardClick={() => {
                    setOpenProjectInfo('info');
                  }}
                  onFolderClick={
                    !template
                      ? () => {
                          setOpenProjectInfo('files');
                        }
                      : undefined
                  }
                  menuBadge={numChats}
                  menuItems={[
                    // {
                    //   badge: numChats,
                    //   label: 'Project Details',
                    //   onClick: () => {
                    //     setOpenProjectInfo('info');
                    //   },
                    // },
                    ...(template
                      ? []
                      : [
                          {
                            label: 'Create Template from Project',
                            onClick: async () => {
                              try {
                                const newTemplate = await createProjectTemplate(
                                  {
                                    title: project?.title,
                                    details: project?.details,
                                    project: Number(id),
                                  }
                                ).unwrap();
                                navigate(
                                  `/project_template/${newTemplate?.project}`
                                );
                                toast.info('Template created successfuly');
                              } catch (error) {
                                toast.error(
                                  'Unable to create project template'
                                );
                              }
                            },
                          },
                        ]),
                    {
                      label: `Show ${
                        filter === 'Active' ? 'Archived' : 'Active'
                      }`,
                      onClick: () =>
                        setFilter(filter === 'Active' ? 'Archived' : 'Active'),
                    },
                    {
                      label: 'Tutorial',
                      onClick: () =>
                        setState(currState => {
                          return {
                            ...currState,
                            steps: projectSteps(),
                            stepIndex: 0,
                            run: true,
                            triggers: {
                              ...currState.triggers,
                              openProjectDetailsDrawer: () =>
                                setOpenProjectInfo('info'),
                              closeProjectDetailsDrawer: () =>
                                setOpenProjectInfo(undefined),
                              toggleCalendar: () => {
                                document
                                  .getElementById('calendarExpand')
                                  ?.click();
                              },
                              openCoordinationDrawer: async () => {
                                const elemID = `coordination-21198`;
                                const currentItem = (itemsRef.current as any)[
                                  elemID
                                ];
                                await currentItem.expandParent();
                                const currentNode = (itemsRef.current as any)[
                                  `item-21198`
                                ];
                                currentNode.onClick();
                              },
                              closeCoordinationDrawer: () =>
                                setActiveNode(undefined),
                              openTaskDrawer: async () => {
                                const elemID = `task-21197`;
                                const currentItem = (itemsRef.current as any)[
                                  elemID
                                ];
                                await currentItem.expandParent();
                                const currentNode = (itemsRef.current as any)[
                                  `item-21197`
                                ];
                                currentNode.onClick();
                              },
                              closeTaskDrawer: () => setActiveNode(undefined),
                              openSpeedDial: () => setOpenSpeedDial(true),
                              closeSpeedDial: () => setOpenSpeedDial(false),
                            },
                          };
                        }),
                    },
                    { label: 'Logout', onClick: () => onLogout() },
                  ]}
                />
              )}

              <Container maxWidth={'xl'}>
                <AlertDialog
                  {...(alertDetails || {})}
                  open={!!alertDetails}
                  title={alertDetails?.title || ''}
                  content={alertDetails?.content || ''}
                  onClose={() => {
                    setAlertDetails(undefined);
                  }}
                  // form={alertDetails?.form}
                  // onConfirm={alertDetails?.onConfirm}
                  // confirmLabel={alertDetails?.confirmLabel}
                />
                <AlertForm {...alertFormDetails} />
                <ProjectDnD
                  disabled={disabled}
                  itemsRef={itemsRef}
                  tree={projectTree}
                  onContextMenu={(e: any, payload: any) => {
                    if (e.altKey) return;
                    e.preventDefault();
                    e.stopPropagation();
                    // setHighlightNode(payload);
                    if (
                      !(
                        ['task', 'event', 'coordination', 'item'].includes(
                          payload.nodeType
                        ) &&
                        ['task', 'event', 'coordination', 'item'].includes(
                          payload.parentNodeType
                        )
                      )
                    ) {
                      setAnchorEl({
                        anchor: e.currentTarget,
                        clientX: e.clientX,
                        clientY: e.clientY,
                        data: payload.data,
                      });
                    }
                  }}
                  onClickAway={() => setHighlightNode(undefined)}
                  onNodeClick={payload => {
                    if (disabled) {
                      return;
                    } else if (preview) {
                      setAlertDetails({
                        open: true,
                        onClose: () => {},
                        title: `Navigate to: ${payload?.data?.title}?`,
                        content:
                          'Continue if you would like to navigate to the project and open the item.',
                        onConfirm: async () => {
                          navigate(
                            `/${template ? 'project_template' : 'project'}/${
                              project?.id
                            }/#${payload?.nodeType?.[0]}=${payload?.data?.id}`
                          );
                        },
                      });
                    } else {
                      setActiveNode(payload);
                    }
                  }}
                  // onNodeDoubleClick={payload => {
                  //   if (!preview && !disabled) {
                  //     setHighlightNode(payload);
                  //   }
                  // }}
                  onMoveComplete={onMoveComplete}
                  render={(props: any, children: any[]) =>
                    itemRender(props, children)
                  }
                  styles={projectDnDStyles}
                />
              </Container>
              {activeNode?.nodeType &&
                ['coordination', 'task', 'event', 'item'].includes(
                  activeNode.nodeType
                ) && (
                  <ItemTabDrawer
                    template={template}
                    exampleItem={
                      exampleProject &&
                      ({
                        title: 'Final Approval',
                        crd_status_r: { name: 'Not Started' },
                        crd_project_r: { title: 'Best Practice Project' },
                      } as Coordination)
                    }
                    disabled={disabled}
                    // isEvent={activeNode?.nodeType === 'event'}
                    open={true}
                    transparentBackdrop={true}
                    id={activeNode?.data?.id}
                    project_id={id}
                    afterSave={() => refetchProject()}
                    onClose={() => {
                      setActiveNode(undefined);
                    }}
                  />
                )}
              {activeDialog?.nodeType && (
                <ItemPreviewDialog
                  template={template}
                  disabled={disabled}
                  open={true}
                  transparentBackdrop={true}
                  afterSave={() => refetchProject()}
                  id={activeDialog?.data?.id}
                  project_id={id}
                  onClose={() => {
                    setActiveDialog(undefined);
                  }}
                  subType={activeDialog?.data?.icons}
                  expand={() => {
                    setExpanded(false);
                    setActiveNode(activeDialog);
                    setActiveDialog(undefined);
                  }}
                />
              )}
              {project?.id && openProjectInfo && (
                <ProjectTabDrawer
                  template={template}
                  exampleProject={exampleProject?.project as Project}
                  open={!!openProjectInfo}
                  initialTab={openProjectInfo || ''}
                  id={project.id}
                  archived={project.archived}
                  onClose={() => {
                    setOpenProjectInfo(undefined);
                  }}
                  afterSave={() => refetchProject()}
                />
              )}
              {speedDial && filter !== 'Archived' && (
                <SpeedDial
                  ariaLabel="SpeedDial basic example"
                  sx={{
                    position: 'fixed',
                    right: 0,
                    px: 4,
                    width: '100%',
                    boxSizing: 'border-box',
                    bottom: 64,
                    alignItems: downSm || preview ? 'flex-end' : 'center',
                  }}
                  icon={<SpeedDialIcon id="speeddial" />}
                  onClose={handleCloseSpeedDial}
                  onOpen={handleOpenSpeedDial}
                  open={openSpeedDial}
                >
                  <SpeedDialAction
                    key={'stage'}
                    icon={<ClassOutlined id={'stage-speeddial'} />}
                    tooltipTitle={'Add Stage'}
                    tooltipOpen
                    onClick={async () => {
                      if (highlightNode) {
                        toast.error('A stage cannot be a child item');
                      } else {
                        setAlertFormDetails({
                          open: true,
                          onClose: () => setAlertFormDetails({ open: false }),
                          title: 'Add stage to project',
                          // text: 'Select the type of stage you would like to add.',
                          button: 'ADD',
                          form: [
                            {
                              name: '',
                              itemType: 'typography',
                              label:
                                'Select the type of stage you would like to add.',
                              // jItemProps
                            },
                            {
                              name: 'project_stage',
                              itemType: 'autocomplete',
                              label: 'Project Stage',
                              options: project_stages.filter(
                                s => !!s.subscription
                              ),
                            },
                          ],
                          validationSchema: Yup.object({
                            project_stage: Yup.object()
                              .nullable()
                              .required('Please select a project stage'),
                          }),
                          onConfirm: async (values: any) => {
                            setAlertFormDetails({ open: false });
                            if (highlightNode) {
                              toast.error(`A stage cannot be a child item`);
                            } else {
                              createItem('stage', () =>
                                createStage({
                                  stage: values?.project_stage?.id,
                                  project: id,
                                  template: template,
                                }).unwrap()
                              );
                            }
                          },
                        });
                      }
                    }}
                  />
                  <SpeedDialAction
                    key={'grouping'}
                    icon={
                      <FeaturedPlayListOutlined id={'grouping-speeddial'} />
                    }
                    tooltipTitle={'Add Grouping'}
                    tooltipOpen
                    onClick={async () => {
                      if (!!(highlightNode?.nodeType === 'stage')) {
                        toast.error(
                          `A grouping cannot be a child item to a ${highlightNode?.nodeType}`
                        );
                      } else {
                        createItem('grouping', () =>
                          createGrouping({
                            title: 'Untitled Grouping',
                            project: id,
                            parent_item:
                              highlightNode &&
                              'stage' === highlightNode.nodeType
                                ? highlightNode.id
                                : undefined,
                            template: template,
                          }).unwrap()
                        );
                      }
                    }}
                  />
                  <SpeedDialAction
                    key={'task'}
                    icon={<TaskOutlined id={'task-speeddial'} />}
                    tooltipTitle={'Add Task'}
                    tooltipOpen
                    onClick={async () => {
                      createItem('item', () =>
                        createTask({
                          title: 'Untitled Task',
                          project: id,
                          status: 1,
                          template: template,
                          form: {
                            tabs: {
                              info: {
                                visible: true,
                              },
                              event: {
                                visible: false,
                              },
                              comment: {
                                visible: true,
                              },
                              message: {
                                visible: true,
                              },
                            },
                          },
                        }).unwrap()
                      );
                    }}
                  />
                  <SpeedDialAction
                    key={'event'}
                    icon={<EventOutlined id={'event-speeddial'} />}
                    tooltipTitle={'Add Event'}
                    tooltipOpen
                    onClick={async () => {
                      createItem('item', () =>
                        createTask({
                          title: 'Untitled Event',
                          project: id,
                          status: 1,
                          template: template,
                          form: {
                            tabs: {
                              info: {
                                visible: true,
                              },
                              event: {
                                visible: true,
                              },
                              comment: {
                                visible: true,
                              },
                              message: {
                                visible: false,
                              },
                            },
                          },
                        }).unwrap()
                      );
                    }}
                  />
                </SpeedDial>
              )}
              {calendar && !template && (
                <Box
                  id={'project-calendar'}
                  sx={{
                    position: 'fixed',
                    width: '100%',
                    bottom: 0,
                    backgroundColor: 'white',
                    zIndex: 999,
                  }}
                >
                  <Calendar
                    filters={[
                      [
                        {
                          options: [
                            { label: 'All', filter: 'All' },
                            ...project_stages
                              ?.filter(s => s.subscription)
                              ?.map(s => ({
                                label: `${s.name} stage`,
                                filter: s.name,
                              })),
                            {
                              label: 'Item Start/Due Date(s)',
                              filter: 'task',
                            },
                            { label: 'Event Date(s)', filter: 'event' },
                            {
                              label: 'Message Response Due',
                              filter: 'resp_due',
                            },
                            { label: 'Scheduling Due', filter: 'schedule' },
                          ],
                          label: 'Type',
                          defaultOption: itemType,
                          onChange: (event, newValue) => setItemType(newValue),
                          loading: itemsFetching,
                        },
                        {
                          options: [{ id: -1, name: 'All' }, ...(tags || [])],
                          label: 'Tag',
                          defaultOption: selectedTag,
                          onChange: (event: any, newValue: any) =>
                            setSelectedTag(newValue),
                          loading: itemsFetching,
                        },
                      ],
                    ]}
                    accordion={true}
                    header={{ expanded, setExpanded }}
                    events={
                      itemType?.label != 'All' || selectedTag.name != 'All'
                        ? events.filter(e => {
                            return (
                              (itemType?.label === 'All' ||
                                e?.extendedProps?.icons?.[0] ===
                                  itemType?.filter.toLowerCase() ||
                                (e?.extendedProps?.node?.nodeType === 'stage' &&
                                  e?.title === itemType?.filter)) &&
                              (selectedTag.name === 'All' ||
                                e?.extendedProps?.node?.tags?.filter(
                                  (t: Tag) => t.name === selectedTag.name
                                )?.length > 0)
                            );
                          })
                        : events
                    }
                    items={true}
                    month={true}
                    eventRender={(event: any) => {
                      return itemRender(event.extendedProps.node, [], true);
                    }}
                    eventClick={async (extendedProps: any) => {
                      if (
                        extendedProps?.node?.nodeType !== 'stage' &&
                        extendedProps.icons.includes('task')
                      ) {
                        setActiveDialog(extendedProps.node);
                        // setLoading(true);
                        // const elemID = `${extendedProps?.node?.nodeType}-${extendedProps.node?.data?.id}`;
                        // const currentItem = (itemsRef.current as any)[elemID];
                        // await currentItem.expandParent();
                        // setTimeout(function () {
                        //   currentItem.scrollRef?.current?.scrollIntoView({
                        //     behavior: 'smooth',
                        //   });
                        // }, 500);
                        // currentItem.scrollRef?.current?.scrollIntoView({
                        //   behavior: 'smooth',
                        // });
                        // await waitForInView(elemID);
                        // setTimeout(function () {
                        //   setActiveNode(extendedProps.node);
                        //   setLoading(false);
                        // }, 100);
                      }
                    }}
                    updateEvent={async (event: any) => {
                      switch (event.extendedProps?.node?.nodeType) {
                        case 'stage':
                          await patchStage({
                            id: event.extendedProps?.node?.data?.stage?.id,
                            project: Number(id),
                            due_date: event.end || null,
                            start_date: event.start || null,
                          } as any);
                          break;
                        case 'task':
                          await patchTask({
                            id: event.extendedProps?.node?.data?.task?.id,
                            project: Number(id),
                            due_date: event.end || null,
                            start_date: event.start || null,
                          } as any);
                          break;
                        case 'coordination':
                          await patchCoordination({
                            id: event.extendedProps?.node?.data?.coordination
                              ?.id,
                            project: Number(id),
                            due_date: event.end || null,
                            start_date: event.start || null,
                          } as any);
                          break;
                        case 'event':
                          await patchEvent({
                            id: event.extendedProps?.node?.data?.event?.id,
                            project: Number(id),
                            due_date: event.end || null,
                            start_date: event.start || null,
                          } as any);
                          break;

                        default:
                          break;
                      }
                      await refetchProject();
                    }}
                  />
                </Box>
              )}
            </div>
          );
        }}
      </ProjectContext.Consumer>
    </ProjectProvider>
  );
};

function waitForElm(selector: string) {
  return new Promise(resolve => {
    if (document.getElementById(selector)) {
      return resolve(document.getElementById(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.getElementById(selector)) {
        resolve(document.getElementById(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// eslint-disable-next-line
function waitForAnimation(selector: string) {
  const el = document.getElementById(selector);
  if (el) {
    return new Promise(resolve => {
      const elemFunc = () => {
        resolve(document.getElementById(selector));
        el.removeEventListener('animationend', elemFunc);
      };
      el.addEventListener('animationend', elemFunc);
    });
  }
}

function waitForInView(selector: string) {
  const el = document.getElementById(selector);
  if (el) {
    return new Promise(resolve => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          resolve(document.getElementById(selector));
          observer.disconnect();
        }
      });

      observer.observe(el);
    });
  }
}
